// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
//
//         this.addEventListener('product-info:loaded', ({ target }) => {
//           target.addPreProcessCallback(this.preprocessHTML.bind(this));
//         });
//       }
//
//       hide(preventFocus = false) {
//         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//         this.modalContent.innerHTML = '';
//
//         if (preventFocus) this.openedBy = null;
//         super.hide();
//       }
//
//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');
//
//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             const productElement = responseHTML.querySelector('product-info');
//
//             this.preprocessHTML(productElement);
//             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
//
//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }
//             if (window.ProductModel) window.ProductModel.loadShopifyXR();
//
//             super.show(opener);
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }
//
//       preprocessHTML(productElement) {
//         productElement.classList.forEach((classApplied) => {
//           if (classApplied.startsWith('color-') || classApplied === 'gradient')
//             this.modalContent.classList.add(classApplied);
//         });
//         this.preventDuplicatedIDs(productElement);
//         this.removeDOMElements(productElement);
//         this.removeGalleryListSemantic(productElement);
//         this.updateImageSizes(productElement);
//         this.preventVariantURLSwitching(productElement);
//       }
//
//       preventVariantURLSwitching(productElement) {
//         productElement.setAttribute('data-update-url', 'false');
//       }
//
//       removeDOMElements(productElement) {
//         const pickupAvailability = productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();
//
//         const productModal = productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();
//
//         const modalDialog = productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }
//
//       preventDuplicatedIDs(productElement) {
//         const sectionId = productElement.dataset.section;
//
//         const oldId = sectionId;
//         const newId = `quickadd-${sectionId}`;
//         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
//         Array.from(productElement.attributes).forEach((attribute) => {
//           if (attribute.value.includes(oldId)) {
//             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
//           }
//         });
//
//         productElement.dataset.originalSection = sectionId;
//       }
//
//       removeGalleryListSemantic(productElement) {
//         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;
//
//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }
//
//       updateImageSizes(productElement) {
//         const product = productElement.querySelector('.product');
//         const desktopColumns = product?.classList.contains('product--columns');
//         if (!desktopColumns) return;
//
//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;
//
//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
//
//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }
//
//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }
//     }
//   );
// }

if (!customElements.get('quick-add-modal')) {
    customElements.define(
        'quick-add-modal',
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

                this.addEventListener('product-info:loaded', ({ target }) => {
                    target.addPreProcessCallback(this.preprocessHTML.bind(this));
                });
            }

            hide(preventFocus = false) {
                const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (cartNotification) cartNotification.setActiveElement(this.openedBy);
                if (this.modalContent) this.modalContent.innerHTML = '';

                if (preventFocus) this.openedBy = null;
                super.hide();
            }

            show(opener) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');

                const spinner = opener.querySelector('.loading__spinner');
                if (spinner) spinner.classList.remove('hidden');

                fetch(opener.getAttribute('data-product-url'))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                        const productElement = responseHTML.querySelector('product-info');

                        if (!productElement) {
                            console.error('Product info element not found');
                            // Redirect to product page as fallback
                            window.location.href = opener.getAttribute('data-product-url');
                            return;
                        }

                        this.preprocessHTML(productElement);

                        if (this.modalContent && productElement) {
                            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
                        }

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }
                        if (window.ProductModel) window.ProductModel.loadShopifyXR();

                        super.show(opener);
                    })
                    .catch((error) => {
                        console.error('Quick-add fetch error:', error);
                        // Fallback: redirect to product page
                        window.location.href = opener.getAttribute('data-product-url');
                    })
                    .finally(() => {
                        opener.removeAttribute('aria-disabled');
                        opener.classList.remove('loading');

                        const spinner = opener.querySelector('.loading__spinner');
                        if (spinner) spinner.classList.add('hidden');
                    });
            }

            preprocessHTML(productElement) {
                // Add comprehensive null checks
                if (!productElement) {
                    console.error('ProductElement is null in preprocessHTML');
                    return;
                }

                if (!this.modalContent) {
                    console.error('ModalContent is null in preprocessHTML');
                    return;
                }

                // Safely iterate through classList
                try {
                    if (productElement.classList && productElement.classList.length > 0) {
                        productElement.classList.forEach((classApplied) => {
                            if (classApplied.startsWith('color-') || classApplied === 'gradient') {
                                this.modalContent.classList.add(classApplied);
                            }
                        });
                    }
                } catch (error) {
                    console.error('Error processing classList:', error);
                }

                this.preventDuplicatedIDs(productElement);
                this.removeDOMElements(productElement);
                this.removeGalleryListSemantic(productElement);
                this.updateImageSizes(productElement);
                this.preventVariantURLSwitching(productElement);
            }

            preventVariantURLSwitching(productElement) {
                if (productElement && productElement.setAttribute) {
                    productElement.setAttribute('data-update-url', 'false');
                }
            }

            removeDOMElements(productElement) {
                if (!productElement) return;

                const pickupAvailability = productElement.querySelector('pickup-availability');
                if (pickupAvailability) pickupAvailability.remove();

                const productModal = productElement.querySelector('product-modal');
                if (productModal) productModal.remove();

                const modalDialogs = productElement.querySelectorAll('modal-dialog');
                if (modalDialogs && modalDialogs.length > 0) {
                    modalDialogs.forEach((modal) => modal.remove());
                }
            }

            preventDuplicatedIDs(productElement) {
                if (!productElement || !productElement.dataset) return;

                const sectionId = productElement.dataset.section;
                if (!sectionId) return;

                const oldId = sectionId;
                const newId = `quickadd-${sectionId}`;

                try {
                    productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

                    if (productElement.attributes) {
                        Array.from(productElement.attributes).forEach((attribute) => {
                            if (attribute.value && attribute.value.includes(oldId)) {
                                productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
                            }
                        });
                    }

                    productElement.dataset.originalSection = sectionId;
                } catch (error) {
                    console.error('Error in preventDuplicatedIDs:', error);
                }
            }

            removeGalleryListSemantic(productElement) {
                if (!productElement) return;

                const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
                if (!galleryList) return;

                galleryList.setAttribute('role', 'presentation');
                const slides = galleryList.querySelectorAll('[id^="Slide-"]');
                if (slides) {
                    slides.forEach((li) => li.setAttribute('role', 'presentation'));
                }
            }

            updateImageSizes(productElement) {
                if (!productElement) return;

                const product = productElement.querySelector('.product');
                if (!product) return;

                const desktopColumns = product.classList.contains('product--columns');
                if (!desktopColumns) return;

                const mediaImages = product.querySelectorAll('.product__media img');
                if (!mediaImages || mediaImages.length === 0) return;

                let mediaImageSizes =
                    '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

                if (product.classList.contains('product--medium')) {
                    mediaImageSizes = mediaImageSizes.replace('715px', '605px');
                } else if (product.classList.contains('product--small')) {
                    mediaImageSizes = mediaImageSizes.replace('715px', '495px');
                }

                mediaImages.forEach((img) => {
                    if (img && img.setAttribute) {
                        img.setAttribute('sizes', mediaImageSizes);
                    }
                });
            }
        }
    );
}
